<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section page-top-section">
        <div class="wrapper">
          <div class="title title-96">My Profile</div>
          <img src="./../images/crew.webp" class="img" />
        </div>
      </div>
      <section class="section page-body-section cart-section balance-section">
        <div class="circle"></div>
        <img src="./../images/squares.webp" class="squares" />
        <div class="wrapper">
          <div class="profile-form">
            <div class="profile-form-wrapper">
              <div class="wrapper form-fields-wrapper">
                <div class="desc medium">Personal Information</div>
                <div>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> First name:
                    </div>
                    <input
                      type="text"
                      placeholder="First name"
                      v-model="name"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc">
                      <span class="red">*</span> Last name:
                    </div>
                    <input
                      type="text"
                      placeholder="Last name"
                      v-model="surname"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc"><span class="red">*</span> E-mail:</div>
                    <input type="email" placeholder="E-mail" v-model="email" />
                  </label>
                  <label class="input-container">
                    <div class="desc"><span class="red">*</span> Nickname:</div>
                    <input
                      type="text"
                      placeholder="Nickname"
                      v-model="nickname"
                    />
                  </label>
                  <label class="input-container">
                    <div class="desc"><span class="red">*</span> Phone:</div>
                    <input type="tel" placeholder="Phone" v-model="phone" />
                  </label>
                </div>
                <button class="button" @click="updateProfileData">
                  <span>Save</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="profileUpdateErrorMessaage">
                    {{ profileUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="profileUpdateSuccessMessaage">
                    {{ profileUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
              <div class="wrapper form-fields-wrapper">
                <div class="desc medium">Change Password</div>
                <label class="input-container">
                  <div class="desc">
                    <span class="red">*</span> Current password:
                  </div>
                  <input
                    type="text"
                    placeholder="Current password"
                    v-model="curPass"
                  />
                </label>
                <label class="input-container">
                  <div class="desc">
                    <span class="red">*</span> New password:
                  </div>
                  <input
                    type="text"
                    placeholder="New password"
                    v-model="newPass"
                  />
                </label>
                <label class="input-container">
                  <div class="desc">
                    <span class="red">*</span> Confirm password:
                  </div>
                  <input
                    type="text"
                    placeholder="Confirm password"
                    v-model="repeatPass"
                  />
                </label>
                <div class="pass-rules">
                  <div class="desc bold">Password must contain:</div>
                  <div class="desc">
                    - At least 6 characters, 1 upper case letter (A-Z), 1 lower
                    case letter (a-z), 1 number (0-9)
                  </div>
                </div>
                <button class="button" @click="updatePassword">
                  <span>Save</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="passUpdateErrorMessaage">
                    {{ passUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="passUpdateSuccessMessaage">
                    {{ passUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
export default {
  name: "Profile",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      nickname: "",
      phone: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
    };
  },
  watch: {
    currency: function () {
      this.$emit("fetchOrderHistory");
    },
  },
  mounted() {
    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
        this.nickname = res.data.nickname;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        surname: this.surname,
        nickname: this.nickname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              this.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
};
</script>
